import React, { Component } from 'react';
import Video from './video';
import Crucero from './crucero';
import Footer from './footer';
import Head from '../../router/header';
import Resorts from './resorts';
import AboutUs from './aboutUs';

class Home extends Component {
    render() {
        return (
            <div>
                <Head/>
                <Video/>   
                <AboutUs/>   
                <Crucero/>  
                <Resorts/>
                <Footer/>
            </div>
        );
    }
}

export default Home;